import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = [
        'container',
        'prototype',
    ];

    static values = {
        index: Number,
    };

    declare readonly containerTarget: HTMLElement;
    declare readonly prototypeTarget: HTMLTemplateElement;
    declare indexValue: number;

    add(event: Event): void {

        event.preventDefault();

        const content = this.prototypeTarget.innerHTML
            .replace(/__name__/g, String(this.indexValue));

        const wrapper = document.createElement('div');

        wrapper.innerHTML = content;

        const element = wrapper.firstElementChild;

        if (element) {

            this.containerTarget.appendChild(element);

            this.indexValue++;
        }
    }

    remove(event: Event): void {

        event.preventDefault();

        const button = event.currentTarget as HTMLElement;

        const card = button.closest('.card');

        if (card) {
            card.remove();
        }
    }
}
